import { jsx as e, jsxs as c } from "react/jsx-runtime";
import { Fragment as u, useState as I, useEffect as $ } from "react";
import { c as m } from "./index-98c703e1.mjs";
import { u as n, a as o } from "./index-6a632112.mjs";
import { m as C, B as G } from "./themes-5f0b3c3d.mjs";
import { h as f } from "./hTag-40b23797.mjs";
import { Divider as L } from "./divider.js";
import { S as T } from "./caretRight-e0ea6357.mjs";
import { Image as k } from "./image.js";
import { MediaDisclosureButton as N } from "./mediaDisclosureButton.js";
import { useWindowDimensions as x } from "./useWindowDimensions.js";
import "./_commonjsHelpers-d4512b9c.mjs";
import "./types-b577bf77.mjs";
import "./aspectRatio.js";
import "./lineHeights-72d3110c.mjs";
import "./zIndices-d07533f3.mjs";
const b = 6, w = n.li`
  &.MarketingList__ListItem {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.MarketingListItem)};
  }
`, E = n.ul`
  &.MarketingList__Group {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.MarketingListGroupWrapper)};
  }
`, H = n.span`
  &.MarketingList__ListIconContainer {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.MarketingListIconContainer)};
  }
`, j = ({
  bulletType: t = "dot",
  spacing: i = "default",
  variant: p = "photoSplitShort",
  textWeight: r = "regular",
  iconBulletProps: s,
  listItems: l = []
}) => {
  if (l?.length > b)
    throw new Error(
      "exceeded max list items length; list items length cannot exceed 6 per marketing list group."
    );
  return /* @__PURE__ */ e(
    E,
    {
      className: m([
        "MarketingList__Group",
        `MarketingList__Group--${p}`,
        `MarketingList__Group--${t}`,
        `MarketingList__Group--${i}`
      ]),
      children: l?.map((a, d) => /* @__PURE__ */ c(u, { children: [
        /* @__PURE__ */ c(
          w,
          {
            className: m([
              "MarketingList__ListItem",
              `MarketingList__ListItem--${r}`
            ]),
            children: [
              t === "icon" && /* @__PURE__ */ e(D, { ...s }),
              a
            ]
          }
        ),
        i === "divider" && d < l.length - 1 && /* @__PURE__ */ e(L, {})
      ] }, d))
    }
  );
}, D = ({
  icon: t = T,
  color: i = C.primary
}) => /* @__PURE__ */ e(
  H,
  {
    role: "img",
    className: "MarketingList__ListIconContainer",
    children: /* @__PURE__ */ e(
      t,
      {
        width: "20px",
        height: "20px",
        color: i,
        "data-testid": "marketing-list-bullet-icon"
      }
    )
  }
), R = n.div`
  &.MarketingList__Media {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.MediaWrapper)};
  }
`, B = n.div`
  ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.GraphicWrapper)};
`, F = ({
  disclosureLinks: t,
  imageProps: i,
  icon: p,
  variant: r
}) => {
  const { width: s } = x(), [l, a] = I("1/1");
  return $(() => {
    r === "photoSplitShort" ? s < 600 ? a("3/2") : s >= 600 && a("1/1") : r === "photoSplitLong" && (s < 600 ? a("3/2") : s >= 600 && a("3/4"));
  }, [s, r]), /* @__PURE__ */ c(
    R,
    {
      className: m([
        "MarketingList__Media",
        `MarketingList__Media--${r}`
      ]),
      "data-testid": "marketing-list-media",
      children: [
        ["photoSplitLong", "photoSplitShort"].includes(r) && i && /* @__PURE__ */ e(
          k,
          {
            objectFit: "fill",
            radii: "8px",
            ...i,
            src: i?.src,
            ratio: l,
            "data-testid": "marketing-list-media-image"
          }
        ),
        ["textStacked", "textSplit"].includes(r) && (p || i) && /* @__PURE__ */ e(B, { "data-testid": "marketing-list-media-icon-wrapper", children: p || i && /* @__PURE__ */ e(
          k,
          {
            objectFit: "fill",
            radii: "8px",
            ...i,
            src: i?.src,
            "data-testid": "marketing-list-media-image"
          }
        ) }),
        t && /* @__PURE__ */ e(
          N,
          {
            alignment: "bottom-right",
            containerPosition: {
              bottom: ["photoSplitLong", "photoSplitShort"].includes(r) ? "8px" : "2px",
              right: ["photoSplitLong", "photoSplitShort"].includes(r) ? "24px" : "2px"
            },
            ...t
          }
        )
      ]
    }
  );
}, z = 4, O = n.div`
  &.MarketingList {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.Wrapper)};
  }
`, V = n.div`
  &.MarketingList__ImageContainer {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.ImageContainer)};
  }
`, X = n.div`
  &.MarketingList__ListContainer {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.ListContainer)};
  }
`, K = n.div`
  &.MarketingList__HeadingWrapper {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.HeadingWrapper)};
  }
`, U = n(f)`
  &.MarketingList__TitleWrapper {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.TitleWrapper)};
  }
`, q = n(f)`
  &.MarketingList__SubTitleWrapper {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.SubTitleWrapper)};
  }
`, S = n.div`
  ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.VerticalDivider)};
`, y = n.div`
  &.MarketingList__GroupSet {
    ${({
  theme: {
    components: { marketingList: t }
  }
}) => o(t.MarketingListGroupSetWrapper)};
  }
`, lt = ({
  variant: t = "photoSplitShort",
  imageAlignment: i = "left",
  titleProp: p = { headingLevel: "h2", title: "", size: "extraLarge" },
  subTitleProp: r = { headingLevel: "h3", subTitle: "" },
  mediaProps: s,
  showGroupDivider: l = !0,
  groups: a,
  dataTestId: d = "marketing-list"
}) => {
  const g = x().width < G.tabletMin;
  i = g || t === "textSplit" ? "left" : i;
  const _ = () => /* @__PURE__ */ c(K, { className: "MarketingList__HeadingWrapper", children: [
    /* @__PURE__ */ e(
      U,
      {
        className: m([
          "MarketingList__TitleWrapper",
          `MarketingList__TitleWrapper--${p?.size}`
        ]),
        as: p?.headingLevel,
        children: p?.title
      }
    ),
    r?.subTitle && /* @__PURE__ */ e(
      q,
      {
        className: "MarketingList__SubTitleWrapper",
        as: r?.headingLevel,
        children: r?.subTitle
      }
    )
  ] }), M = () => /* @__PURE__ */ c(
    V,
    {
      className: m([
        "MarketingList__ImageContainer",
        `MarketingList__ImageContainer--${t}`
      ]),
      children: [
        s && (s?.icon || s?.imageProps) && /* @__PURE__ */ e(F, { variant: t, ...s }),
        !["photoSplitShort", "photoSplitLong"].includes(t) && _()
      ]
    }
  );
  if (a.length > z)
    throw new Error(
      "exceeded max group length; group length cannot exceed 4 per marketing list."
    );
  return /* @__PURE__ */ c(
    O,
    {
      className: m(["MarketingList", `MarketingList--${t}`]),
      "data-testid": d,
      children: [
        (i === "left" || ["textStacked", "textSplit"].includes(t)) && M(),
        ["textStacked"].includes(t) && /* @__PURE__ */ e(L, {}),
        ["textSplit"].includes(t) && g && /* @__PURE__ */ e(L, {}),
        ["textSplit"].includes(t) && !g && /* @__PURE__ */ e(S, {}),
        /* @__PURE__ */ c(
          X,
          {
            className: m([
              "MarketingList__ListContainer",
              `MarketingList__ListContainer--${t}`
            ]),
            children: [
              ["photoSplitShort", "photoSplitLong"].includes(t) && _(),
              /* @__PURE__ */ e(
                y,
                {
                  className: m([
                    "MarketingList__GroupSet",
                    `MarketingList__GroupSet--${t}`
                  ]),
                  children: a?.map((W, h) => /* @__PURE__ */ c(u, { children: [
                    /* @__PURE__ */ e(j, { variant: t, ...W }),
                    (["photoSplitShort", "photoSplitLong", "textSplit"].includes(
                      t
                    ) || g) && h < a?.length - 1 && l && /* @__PURE__ */ e(L, {}),
                    t === "textStacked" && !g && (![0, 2].includes(h) || h < a?.length - 1 && l && /* @__PURE__ */ e(S, {}))
                  ] }, h))
                }
              )
            ]
          }
        ),
        i === "right" && !["textStacked", "textSplit"].includes(t) && M()
      ]
    }
  );
};
export {
  lt as MarketingList
};
